import React, { Component } from 'react';
import RDP_CONFIG from '../../config';
import { UserService } from '../../services/user';
import './element-audio-properties.css';
import {
  RDPDamWidget, ColorPicker
} from '../../components';
import PreferenceRequiredInteraction
  from "../../components/preference-required-interaction/preference-required-interaction";

export default class ElementAudioProperties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "content": this.props.content,
      "dam_widget_opened": false,
      "dam_widget_type": "audio"
    }

    this.onAudioChange = this.onAudioChange.bind(this);
    this.onTranscriptChange = this.onTranscriptChange.bind(this);
    this.onContentTitleChange = this.onContentTitleChange.bind(this);
    this.onBackgroundColorChange = this.onBackgroundColorChange.bind(this);
    this.onPaddingTopChange = this.onPaddingTopChange.bind(this);
    this.onPaddingBottomChange = this.onPaddingBottomChange.bind(this);
  }

  onAudioChange() {
    this.setState({
      "dam_widget_opened": true,
      "dam_widget_type": "audio"
    })
  }

  onTranscriptChange(e) {
    var content = this.state.content;
    content.transcript = e.currentTarget.value;
    this.setState({ "content": content }, () => {
      this.props.onContentChange(content)
    });
  }

  onContentTitleChange(e) {
    var content = this.state.content;
    content.content_title = e.currentTarget.value !== "" ? e.currentTarget.value : content.content_title;

    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onBackgroundColorChange(color) {
    var content = this.state.content;
    content.background_color = color;
    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onPaddingTopChange(e) {
    var content = this.state.content;
    content.padding_top = e.currentTarget.value !== "" ? e.currentTarget.value : content.padding_top;

    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onPaddingBottomChange(e) {
    var content = this.state.content;
    content.padding_bottom = e.currentTarget.value !== "" ? e.currentTarget.value : content.padding_bottom;

    this.setState({
      "content": content
    }, function () {
      this.props.onContentChange(content)
    });
  }

  onAssetChange(asset, data) {
    var content = this.state.content;
    content.audio = asset;

    this.setState({
      "content": content,
      "dam_widget_opened": false
    }, () => {
      this.props.onContentChange(content)
    })
  }

  onRDPDamWidgetClose() {
    this.setState({
      "dam_widget_opened": false
    })
  }

  renderDAMWidget() {
    if (this.state.dam_widget_opened === true) {
      return <RDPDamWidget
        labels={this.props.labels}
        type={this.state.dam_widget_type}
        onClose={() => this.onRDPDamWidgetClose()}
        onAssetChange={(asset, data) => this.onAssetChange(asset, data)}
      />;
    }
  }

  getAudioUrl(audio) {
    var accessToken = UserService.getUser().access_token;
    if (audio !== "https://pocs.digitalpages.com.br/rdpcomposer/media/audio-1/audio-1.mp3") {
      audio += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return audio;
  }

  render() {
    var content = this.state.content;
    var labels = this.props.labels;

    return (<div className="rdp-element-audio-properties">
      <ul className="rdp-composer-element-edit-tabs">
        <li className="rdp-composer-element-edit-tabs-item active">{labels.elements.common_settings.label_tab_settings}</li>
      </ul>
      <div className="rdp-composer-element-edit-body">
      <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_audio.settings_label_content_title}:</span>
        <input type="text" className="rdp-composer-element-edit-input" onChange={(e) => this.onContentTitleChange(e)} defaultValue={content.content_title}></input>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_audio.settings_label_audio_file}:</span>
        <audio className="rdp-composer-element-audio" controls src={this.getAudioUrl(content.audio)}></audio>
        <span className="rdp-composer-element-audio-btn" onClick={() => this.onAudioChange()}></span>

        <span className="rdp-composer-element-edit-label" style={{marginTop: '20px'}}>{labels.elements.settings.element_audio.settings_label_transcript}:</span>
        <textarea 
          className="rdp-composer-element-edit-textarea" 
          onChange={(e) => this.onTranscriptChange(e)} 
          value={content.transcript || ''}
          placeholder={labels.elements.settings.element_audio.settings_placeholder_transcript}
          rows="5"
        ></textarea>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_audio.settings_label_background_color}</span>
        <ColorPicker labels={this.props.labels} color={content.background} onChange={this.onBackgroundColorChange} />

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_audio.settings_label_margin_top}</span>
        <input type="number" className="rdp-composer-element-edit-input px" onChange={(e) => this.onPaddingTopChange(e)} defaultValue={content.padding_top}></input>

        <span className="rdp-composer-element-edit-label">{labels.elements.settings.element_audio.settings_label_margin_bottom}</span>
        <input type="number" className="rdp-composer-element-edit-input px" onChange={(e) => this.onPaddingBottomChange(e)} defaultValue={content.padding_bottom}></input>

        <PreferenceRequiredInteraction
          title={labels.elements.settings.preference_required_interaction.title}
          label={labels.elements.settings.preference_required_interaction.label}
          labels={labels}
          content={content}
          onContentChange={c => {
            this.setState({ content: c });
            this.props.onContentChange(c);
          }}
        />
      </div>
      {this.renderDAMWidget()}
    </div>);
  }
}
